import React, { useState, useLayoutEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { FaGreaterThan, FaMicrophone, FaCheck, FaTrashAlt, FaPlay, FaRegListAlt, FaRedo  } from 'react-icons/fa';
import HighlightedText from './Highlighted';    
import avatar from '../src/mel.jpg'
const Chatbot = () => {
    const [messages, setMessages] = useState([]);
    const [userInput, setUserInput] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const { transcript, resetTranscript } = useSpeechRecognition();
    const chatEndRef = useRef(null);
    const [audioUrl, setAudioUrl] = useState(null);
   //const [aiAudioUrl, setAiAudioUrl] = useState(null);
    const [pronunciationErrorsDisplay, setPronunciationErrorsDisplay] = useState({});
    const [grammarErrorsDisplay, setGrammarErrorsDisplay] = useState([]);
    const [userId, setUserId] = useState('guest');
    const [accumulatedMistakes, setAccumulatedMistakes] = useState({grammar: [], pronunciation: []});
    const [mistakeSummary, setMistakeSummary] = useState("");
    //const responseCacheRef = useRef({});

    //const API_BASE_URL = "https://mel.inglesconmel.com:8000";
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    //const API_BASE_URL = "http://localhost:3001";
    //const API_BASE_URL = "http://209.38.67.1:8000";
    
useLayoutEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
}, [messages]);
    
//if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
  //  return <span>Your browser does not support speech recognition.</span>;
//}
    
const generateAudio = useCallback( async (text) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/generate-audio/`, { text });
        //setAudioUrl(response.data.audioUrl); 
        //const fullAudioUrl = `${API_BASE_URL}${response.data.audioUrl}`;
        const fullAudioUrl = `https://mel-bot.me/${response.data.audioUrl}`;
        //setAudioUrl(`<span class="math-inline">\{API\_BASE\_URL\}/static/</span>{response.data.audioUrl}`);
        setAudioUrl(fullAudioUrl);
    } catch (error) {
        console.error('Error generating audio:', error);
        setAudioUrl(null);
    }
}, [API_BASE_URL, setAudioUrl]);

const optimizeInput = useCallback((text) => {
    return text.replace(/\b(the|that|this|very|just|really)\b/gi, "").replace(/\s+/g, " ").trim();
}, []);


const sendMessage = useCallback (async (input, isVoice = false, audioFile = null) => {
    if (!input.trim() && !audioFile) return;
    
    try {
        let transcribedText = input;
        let pronunciationErrors = [];
        let grammarCorrection = '';

        if (isVoice && audioFile) {
            const formData = new FormData();
            formData.append("file", audioFile);

            const speechResponse = await axios.post(`${API_BASE_URL}/speech-to-text/`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            transcribedText = speechResponse.data.text;
            pronunciationErrors = speechResponse.data.pronunciation_errors || [];
        }

        // Grammar check
        const grammarResponse = await axios.post(`${API_BASE_URL}/check-grammar/`, { text: transcribedText });
        if (grammarResponse.data.corrected_text !== transcribedText) {
            grammarCorrection = grammarResponse.data.corrected_text;
        }

       

        // **Update mistake tracking** stores them separately
        let newMistakes = {
            grammar: grammarCorrection ? [grammarCorrection] : [],
            pronunciation: pronunciationErrors
        };

        setAccumulatedMistakes((prev) => ({
            grammar: [...prev.grammar, ...newMistakes.grammar],
            pronunciation: [...prev.pronunciation, ...newMistakes.pronunciation]
        }));

        // Track mistakes in backend
        //await Promise.all([...newMistakes.grammar, ...newMistakes.pronunciation].map(async (word) => {
        //    return axios.post(`${API_BASE_URL}/track-mistakes/?user_id=${userId}`, {
         //       user_id: userId,
         //       word: word,
          //      incorrect: true,
         //   });
       //}));

        await Promise.all([
            ...newMistakes.grammar.map(word => ({ word, type: "grammar" })),
            ...newMistakes.pronunciation.map(word => ({ word, type: "pronunciation" }))
        ].map(async ({ word, type }) => {
            try {
                await axios.post(`${API_BASE_URL}/track-mistakes/`, {
                    user_id: userId,
                    word: word,
                    //incorrect: true,
                    mistake_type: type, // Added mistake_type
                });
            } catch (error) {
                console.error(`Error tracking mistake for word "${word}" (${type}):`, error);
            }
        }));
        
        // Construct messages
        //Highlight Mistakes
        //let highlightedText = transcribedText;
       // [...newMistakes.grammar, ...newMistakes.pronunciation].forEach((mistake) => {
         //   const regex = new RegExp(`\\b${mistake}\\b`, "gi");
         //   highlightedText = highlightedText.replace(regex, `<span class="highlight">${mistake}</span>`);
       // });

            

        /***Store Messages (User & AI Response) ***/
       // let userMessage = {
        //    user: 'You',
        //    text: highlightedText, // Highlighted mistakes
        //};
        let mistakes = [...newMistakes.grammar, ...newMistakes.pronunciation];

        let userMessage = {
        user: 'You',
        text: transcribedText,
        mistakes: mistakes,
        //audioUrl: null,
        };

         // Optimize input
         const optimizedText = optimizeInput((grammarCorrection || transcribedText) ?? "" );
         // AI Response (cached if possible)
         //const cacheKey = optimizedText.toLowerCase();
         //let aiResponse = responseCacheRef.current[cacheKey];
 
         //if (!aiResponse) {
             const chatResponse = await axios.post(`${API_BASE_URL}/chat/`, { user_input: optimizedText});//, user_id: userId });    
             const aiData = chatResponse.data.response.text || chatResponse.data.response;
             const aiResponse = typeof aiData === "string" ? aiData : aiData.text || "Error getting response";
             //let aiResponse;
            //if (typeof chatResponse.data.response === 'object' && chatResponse.data.response !== null && chatResponse.data.response.text) {
               // aiResponse = chatResponse.data.response.text;
            //} else if (typeof chatResponse.data.response === 'string') {
               // aiResponse = chatResponse.data.response;
            //}else{
            //aiResponse = "Error getting response aquí."; //add an error message if the response is not valid
             //responseCacheRef.current[cacheKey] = aiResponse;
    //}
        let aiMessage = { 
            user: 'Mel ', 
            text: aiResponse|| "Error getting response.",
            avatar: avatar,
         };
        

        
        //const generatedAiAudio = await generateAudio(aiResponse);
        //setAiAudioUrl(generatedAiAudio);

        


        if (newMistakes.grammar.length > 0 || newMistakes.pronunciation.length > 0) {
            //const audioUrlResult = await generateAudio(grammarCorrection || transcribedText);
            generateAudio(grammarCorrection || transcribedText);
            //if (audioUrlResult) {
               // userMessage.audioUrl = audioUrlResult; // Assign the returned audioUrl
           // }
            setPronunciationErrorsDisplay(pronunciationErrors);
            setGrammarErrorsDisplay(grammarCorrection ? [grammarCorrection] : []);
        } else {
            
            setAudioUrl(transcribedText);
            setPronunciationErrorsDisplay([]);
            setGrammarErrorsDisplay([]);
        }

        setMessages((prevMessages) => [...prevMessages, userMessage, aiMessage]);
        setUserInput('');
        resetTranscript();

    } catch (error) {
        console.error('Error sending message:', error);
        setMessages((prevMessages) => [
            ...prevMessages,
            { user: 'You', text: input || "Audio message failed." },
            { user: 'Mel', text: "Error. Please try again later." },
        ]);
    }
}, [API_BASE_URL, userId, optimizeInput,generateAudio, resetTranscript]);

/*** Clear Mistakes ***/
const clearMistakes = () => {
    setAccumulatedMistakes({ grammar: [], pronunciation: [] });
};

/*** AI Summarizes Mistakes ***/
const summarizeMistakes = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/mistake-analysis/`, { params: { user_id: userId }});
        setMistakeSummary(response.data.summary);
    } catch (error) {
        console.error("Error summarizing mistakes:", error);
    }
};
    


const handleSend = () => {
    if (userInput.trim()) {
        sendMessage(userInput);
    }
};
    
const handleStartRecording = () => {
    setIsRecording(true);
    SpeechRecognition.startListening({ continuous: false, maxAlternatives: 1, timeout: 10000 });
};
    
const handleStopRecording = () => {
    setIsRecording(false);
    sendMessage(transcript, true);
};        
    
const handleCancelRecording = () => {
    setIsRecording(false);
    resetTranscript();
};

const handlePlayAudio = () => {
    if (!audioUrl) {
        console.error("No audio URL available");
        return;
    }
    const audio = new Audio(audioUrl);
    audio.onerror = () => alert("Failed to load audio.");
    audio.play();
};

    
    
    
return (
    <div style={styles.container}>
        <h1 style={{ color: "#ffbac4" }}>MELbot</h1>

        
        {!useSpeechRecognition ? (
            <span>Your browser does not support speech recognition.</span>
        ) : (
            <>
        <div style={styles.chatBox}>
            {messages?.length > 0 && messages.map((msg, index) => {
                if (msg.user === 'You') { 
                    return (
                <div key={index} style= {styles.userMessageContainer}>
                    <div style={styles.userMessage}>
                        <strong>{msg.user}: </strong>{msg.text}
                       
                        {audioUrl && (
                            <button style={styles.audioButton} onClick = {handlePlayAudio}>
                                <FaPlay size={16} color="gray" />
                            </button>
                        )}
                    </div>
                </div>
            );
            } else {
                return (
                <div key={index} style= {styles.aiMessageContainer}>
                    <div style={styles.aiMessage}>
                        <strong>{msg.user}: </strong>{msg.text}
                        
                      
                        <div style={{
                            ...styles.avatar,
                            backgroundImage: `url(${msg.avatar || avatar})`
                        }}></div>
                    </div>
                </div>
            );
        }
    })}
            <div ref={chatEndRef}></div>
        </div>
    
        <div style={styles.inputContainer}>
            <input
                type="text"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                placeholder="Chismea..."
                style={styles.input}
               // onKeyDown={(e) => {
                  //  if (e.key === "Enter") {
                    //    handleSend(); // Calls the send message function
                   // }
                //}}
            />
            {userInput.trim() ? (
                <button onClick={handleSend} style={styles.sendButton}>
                    <FaGreaterThan size={20} color="gray" />
                </button>
            ) : (
                <div style={styles.voiceControls}>
                    {!isRecording ? (
                        <button onClick={handleStartRecording} style={styles.micButton}>
                            <FaMicrophone size={20} color="gray" />
                        </button>
                    ) : (
                        <>
                            <button onClick={handleStopRecording} style={styles.checkButton}>
                                <FaCheck size={20} color="gray" />
                            </button>
                            <button onClick={handleCancelRecording} style={styles.cancelButton}>
                                <FaTrashAlt size={20} color="gray" />
                            </button>
                        </>
                    )}
                </div>
            )}
        </div>
        
        <div style={styles.errorDisplay}>
            <div style={styles.voiceControls}>
            <button onClick={summarizeMistakes} style={styles.summarizeClearButton}>
                    <FaRegListAlt size={16} color="gray" />
                    </button>
                    <button onClick={clearMistakes} style={styles.summarizeClearButton}>
                    <FaRedo FaRegListAlt size={16} color="gray" />
                    </button>
            </div>
            {(accumulatedMistakes.grammar.length > 0 || accumulatedMistakes.pronunciation.length > 0) && (
                <div>
                    <h4 style={{ color: "#ffbac4" }}>Grammar Mishaps:</h4>
                    <p>{accumulatedMistakes.grammar.join(", ")}</p>

                    <h4 style={{ color: "#ffbac4" }}>Pronunciation Mistakes:</h4>
                    <p>{accumulatedMistakes.pronunciation.join(", ")}</p>
                </div>
            )}
            {mistakeSummary && (
                <div style={{ marginTop: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", background: "#f9f9f9" }}>
                    <h4 style={{ color: "#ffbac4" }}>Mishaps Summary:</h4>
                    <p>{mistakeSummary}</p>
                </div>
            )}
            
        </div>
        </>
        )}    
    </div>
    );
};
//const url = "https://www.canva.com/design/DAGgn6q8hlU/t1pfhbXkhJXvj7WSC-DyKQ/view?utm_content=DAGgn6q8hlU&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h26329587f9";   
 
const styles = {
    container: { textAlign: 'center', maxWidth: '600px', margin: 'auto', padding: '20px' },
    chatBox: { border: '1px solid #ffbac4', height: '400px', overflowY: 'auto', padding: '10px', borderRadius: '0px' },
    inputContainer: { display: 'flex', marginTop: '10px',  alignItems: 'center' },
    input: { flex: 1, padding: '10px', borderRadius: '0px', border: '1px solid #ffbac4', color: 'gray'},
    sendButton: { marginLeft: '10px', padding: '10px', borderRadius: '0px', cursor: 'pointer', border: 'none', },
    micButton: { marginTop: '10px', padding: '10px', borderRadius: '50%', cursor: 'pointer', border: 'none', backgroundColor: 'transparent' },
    checkButton: { marginTop: '10px', padding: '10px', borderRadius: '50%', cursor: 'pointer', border: 'none', backgroundColor: 'transparent' },
    cancelButton: { marginTop: '10px', padding: '10px', borderRadius: '50%', cursor: 'pointer', border: 'none', backgroundColor: 'transparent' },
    voiceControls: { display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px' },
    userMessageContainer: { display: 'flex', justifyContent: 'flex-end', position: 'relative', width: '90%', alignSelf:'flex-end', margin: '5px 0' },
    userMessage: { textAlign: 'right', backgroundColor: 'white', color: 'black', padding: '5px 10px', borderRadius: '0px', border: '1px solid #ffbac4', maxWidth: '80%', wordWrap: 'break-word', display: 'inline-block' },
    aiMessageContainer: { display: 'flex', justifyContent: 'flex-start', position: 'relative', width: '90%', alignSelf:'flex-start', margin: '5px 0' },
    aiMessage: { textAlign: 'left', backgroundColor: 'white', color: 'black', padding: '10px 5px', borderRadius: '0px', border: '1px solid #e7e7e7e7', maxWidth: '80%', wordWrap: 'break-word', display: 'inline-block' },
    avatar: { width: '30px', height: '30px', borderRadius: '0px', position: 'absolute', left: '5px', bottom: '0px',  backgroundSize: 'cover', backgroundPosition: 'center', backgroundImage: avatar, }, // Or backgroundSize 'contain', '100% 100%', etc.
    audioButton: { background: 'transparent', border: 'none', borderRadius: '5px', padding: '2px 5px', marginLeft: '5px', cursor: 'pointer', },
    errorDisplay: { marginTop: '10px', textAlign: 'left', padding: '10px', borderTop: '1px solid #ccc', },
    summarizeClearControls: { display: 'flex', justifyContent: 'end', gap: '10px', marginTop: '10px' },
    summarizeClearButton: { marginTop: '10px', padding: '10px', borderRadius: '50%', cursor: 'pointer', border: 'none', backgroundColor: 'transparent' },
};

export default Chatbot;